import { render, staticRenderFns } from "./RechargeDealer.vue?vue&type=template&id=54a8a0ac&scoped=true"
import script from "./RechargeDealer.vue?vue&type=script&lang=js"
export * from "./RechargeDealer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a8a0ac",
  null
  
)

export default component.exports